import { Link } from 'react-router-dom';

const friendLinks = [
  { label: '新闻频道', to: '/category/news' },
  { label: '生活频道', to: '/category/life' },
  { label: '娱乐频道', to: '/category/entertainment' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-lg font-black text-background-50">
                91
              </span>
              <span className="font-heading text-xl font-bold text-background-50">91网站</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              91网站是一家覆盖新闻资讯、生活服务、娱乐内容等多个领域的综合门户平台，致力于为用户提供权威、及时、实用的信息与便捷的在线服务。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-video-line', label: '视频号' },
                { icon: 'ri-mail-line', label: '邮箱' },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  aria-label={s.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-800 text-secondary-200 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">频道导航</h4>
            <ul className="mt-4 space-y-2.5">
              {['新闻', '生活', '娱乐'].map((name, i) => (
                <li key={name}>
                  <Link
                    to={['/category/news', '/category/life', '/category/entertainment'][i]}
                    className="text-sm text-secondary-300 transition-colors hover:text-accent-400"
                  >
                    {name}频道
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search" className="text-sm text-secondary-300 transition-colors hover:text-accent-400">
                  全站搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系与支持</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                400-91-91-091
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                service@91portal.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区门户大厦 91 号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-800 pt-6">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-secondary-400">
            <span className="text-secondary-300">友情链接：</span>
            {friendLinks.map((l) => (
              <Link key={l.to} to={l.to} className="whitespace-nowrap transition-colors hover:text-accent-400">
                {l.label}
              </Link>
            ))}
          </div>
          <div className="mt-5 flex flex-col gap-2 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 91网站 版权所有 · 京ICP备2026000001号</span>
            <span className="text-secondary-400">本站内容为演示数据，仅用于产品展示</span>
          </div>
        </div>
      </div>
    </footer>
  );
}